import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=2ca52d1d"
import script from "./Base.vue?vue&type=script&setup=true&lang=js"
export * from "./Base.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca52d1d')) {
      api.createRecord('2ca52d1d', component.options)
    } else {
      api.reload('2ca52d1d', component.options)
    }
    module.hot.accept("./Base.vue?vue&type=template&id=2ca52d1d", function () {
      api.rerender('2ca52d1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/dialogs/Base.vue"
export default component.exports